module.exports = __webpack_public_path__ + "static/media/variation.b2f8fc98.svg";